module.exports = __webpack_public_path__ + "static/media/icon_ceramic_metal_2.059a3a02.svg";